// extracted by mini-css-extract-plugin
export default {"w":"score_w__93M4j","num":"score_num__gOQri","link":"score_link__Quk5T"};